import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { GrupoEconomicoService } from '../grupo-economico-service/grupo.economico.service';
import { ListaBase } from './../../../../shared/crud/ListaBase';
import { EstruturaGridViewBuilder } from './../../../../shared/gridview/EstruturaGridViewBuilder';

@Component({
  selector: 'app-grupo-economico-lista',
  templateUrl: '../../template/lista.html',
  styleUrls: ['./grupo-economico-lista.component.css']
})
export class GrupoEconomicoListaComponent
  extends ListaBase
  implements OnInit {
  visualizarTotalRegistros: boolean;
  exibirBotaoDetalhes: boolean;

  constructor(service: GrupoEconomicoService, toastr: ToastrService, router: Router) {
    super(service, toastr, router);
    this.visualizarTotalRegistros = true;
    this.listagemComPaginacao = true;
    this.quantidadeRegistrosPorPagina = 5;
    this.exibirBotaoDetalhes = true;
  }

  ngOnInit() {
    this.buscar();
    this.estrutura = new EstruturaGridViewBuilder()
      .addColuna('descricao', 'parametros.grupoEconomico.descricao')
      .build();
  }

  protected getListagemComFiltros(): boolean {
    return this.filtros.id
      || this.filtros.descricao;
  }

}
